function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
}

function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
}

function loadScript(src, callback) {
    const script = document.createElement('script');
    script.src = src;
    script.onload = callback;
    document.head.appendChild(script);
}

if (typeof Spinner === 'undefined') {
    loadScript("//cdnjs.cloudflare.com/ajax/libs/spin.js/2.3.2/spin.min.js", function() {
        setTimeout(function() {
            new Spinner({ top: "50%", scale: 0.5 }).spin(document.getElementById('rv__spinner'));
        }, 450);
    });
}

function removeHandleFromCookie(cookieName,handleToRemove) {
    try {
      let products = JSON.parse(getCookie(cookieName) || '[]');
      products = products.filter(item => item.handle !== handleToRemove);
      setCookie(cookieName, JSON.stringify(products), 365);
    } catch (e) {
      console.warn('Failed removing invalid product from cookie:', handleToRemove);
    }
  }

document.addEventListener('DOMContentLoaded', function () {
  const container = document.getElementById('recently-viewed-products');
  const cookieName = 'rv__recent_products';
  const currentHandle = window.pHandle;
  const maxProducts = 10;

  // =========================
  // STEP 1: GET + UPDATE COOKIE
  // =========================
  let recentProducts = [];

  try {
    const cookieData = getCookie(cookieName);
    recentProducts = cookieData ? JSON.parse(cookieData) : [];
  } catch (e) {
    recentProducts = [];
  }

  const collectionHandle = window.GA_CONTEXT?.collection_handle || '';

  // Remove duplicate current product
  recentProducts = recentProducts.filter(item => item.handle !== currentHandle);

  // Maintain limit
  if (recentProducts.length >= maxProducts) {
    recentProducts.shift();
  }

  // Add latest viewed product
  if (currentHandle) {
    recentProducts.push({
      handle: currentHandle,
      collection: collectionHandle
    });
  }

  // Save updated cookie
  setCookie(cookieName, JSON.stringify(recentProducts), 365);

  // =========================
  // STEP 2: RENDER
  // =========================
  if (!container) return;

  // Exclude current product from display
  const filteredProducts = recentProducts.filter(item => item.handle !== currentHandle);

  if (filteredProducts.length === 0) {
    container.innerHTML = `
      <div class="recent-wrapper-noProduct">
        No Gems Viewed Yet.<br/>
        <span>But our Gemstones are waiting for you.</span>
      </div>
    `;
    return;
  }

  container.innerHTML = '<ul class="recent-wrapper grid product-grid"></ul>';
  const wrapper = container.querySelector('.recent-wrapper');

  let displayed = 0;

  filteredProducts
    .slice()
    .reverse()
    .forEach((item) => {
      if (!item || displayed >= maxProducts) return;

      const productHandle = item.handle;
      const savedCollectionHandle = item.collection;
      const url = `/products/${productHandle}.js`;

      fetch(url)
        .then(response => {
          // Handle deleted / unavailable products
          if (response.status === 404) {
            removeHandleFromCookie(cookieName, productHandle);
            throw new Error(`Product "${productHandle}" no longer exists`);
          }

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          return response.json();
        })
        .then(product => {
          const formattedPrice = formatMoney(product.price, Shopify.currency);

          const sku =
            product.sku && product.sku.trim() !== ''
              ? product.sku
              : product.variants?.[0]?.sku || 'N/A';

          const variantId = product.variants?.[0]?.id;

          // Collection-aware product URL
          const productUrl = savedCollectionHandle
            ? `/collections/${savedCollectionHandle}/products/${productHandle}`
            : product.url;

          const html = `
            <li class="grid__item">
              <div class="card-wrapper product-card-wrapper underline-links-hover">
                <div class="card card--standard card--media" style="--ratio-percent: 100%;">
                  <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100%;">
                    <div class="card__media">
                      <a href="${productUrl}">
                        <img src="${product.featured_image}" alt="${product.title}">
                      </a>
                    </div>
                  </div>
                  <div class="card__content">
                    <h3 class="card__heading h5">
                      <a href="${productUrl}" class="full-unstyled-link">${product.title}</a>
                    </h3>
                    <div class="card-information">
                      <div class="sku-text"><span>SKU: ${sku}</span></div>
                      <div class="price">${formattedPrice}</div>
                    </div>
                  </div>
                </div>
              </div>
              ${
                variantId
                  ? `<button class="add-to-cart-ajax add-to-cart-btn" data-variant-id="${variantId}">
                      Add to Cart
                    </button>`
                  : ''
              }
            </li>
          `;

          wrapper.insertAdjacentHTML('beforeend', html);
          displayed++;
        })
        .catch(err => {
          console.warn('Could not load recently viewed product:', err.message);
        });
    });
});


function formatMoney(cents, Shopify_currency) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  var format = '<span class="money">${{amount}}</span>';

  // Always keep value numeric first
  let value = cents / 100;

  // Apply currency rate if exists
  if (Shopify_currency && Shopify_currency.rate) {
    value = value * Shopify_currency.rate;
  }

  // Convert to string AFTER all math
  const valueStr = value.toFixed(2);

  const [integer, decimal] = valueStr.split('.');

  const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  let currency = '';
  if (Shopify_currency && Shopify_currency.active) {
    currency = ' ' + Shopify_currency.active;
  }

  return format
    .replace('{{amount}}', formattedInteger + '.' + decimal + currency);
}